import React from "react";
import { Typography, Switch, FormControlLabel, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

interface PermissionsControlsProps {
  includeAdmins: boolean;
  onIncludeAdminsChange: (include: boolean) => void;
  userCount: number;
  totalUsers: number;
}

export const PermissionsControls: React.FC<PermissionsControlsProps> = ({
  includeAdmins,
  onIncludeAdminsChange,
  userCount,
  totalUsers,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="caption" color="text.secondary">
        {t("permissionsOverviewDisclaimer")}
      </Typography>
      <Stack>
        <FormControlLabel
          control={
            <Switch
              checked={includeAdmins}
              onChange={(e) => {
                onIncludeAdminsChange(e.target.checked);
              }}
            />
          }
          label={t("includeAdmins")}
        />
        <Typography variant="caption" color="text.secondary">
          {t("includingUsersCount", { userCount, totalUsers })}
        </Typography>
      </Stack>
    </Stack>
  );
};
